import script from "./ChatVue.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatVue.vue?vue&type=script&setup=true&lang=js"

import "./ChatVue.vue?vue&type=style&index=0&id=5103ad8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5103ad8c"]])

export default __exports__